var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramWt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2271 0.539062H6.77021C3.33326 0.539062 0.537109 3.33522 0.537109 6.77216V15.229C0.537109 18.666 3.33326 21.4621 6.77021 21.4621H15.2271C18.664 21.4621 21.4602 18.666 21.4602 15.229V6.77216C21.4601 3.33522 18.664 0.539062 15.2271 0.539062ZM19.355 15.229C19.355 17.509 17.5067 19.3573 15.2268 19.3573H6.76991C4.48997 19.3573 2.64168 17.509 2.64168 15.229V6.77217C2.64168 4.49219 4.48997 2.64393 6.76991 2.64393H15.2268C17.5067 2.64393 19.355 4.49219 19.355 6.77217V15.229ZM5.58759 11.0007C5.58759 8.01682 8.01516 5.58924 10.999 5.58924C13.9829 5.58924 16.4105 8.01678 16.4105 11.0007C16.4105 13.9845 13.9829 16.4121 10.999 16.4121C8.01516 16.4121 5.58759 13.9845 5.58759 11.0007ZM10.9987 14.3073C9.17255 14.3073 7.69216 12.8269 7.69216 11.0007C7.69216 9.17451 9.17259 7.69411 10.9987 7.69411C12.8249 7.69411 14.3053 9.17451 14.3053 11.0007C14.3053 12.8269 12.8249 14.3073 10.9987 14.3073ZM16.4203 6.92632C17.1365 6.92632 17.717 6.34577 17.717 5.62963C17.717 4.91348 17.1365 4.33293 16.4203 4.33293C15.7042 4.33293 15.1236 4.91348 15.1236 5.62963C15.1236 6.34577 15.7042 6.92632 16.4203 6.92632Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramWt);
export default __webpack_public_path__ + "static/media/Instagram-wt.b4090e3d125278e2989d77b3ddf44448.svg";
export { ForwardRef as ReactComponent };